import React from 'react';
import { Field, getIn } from 'formik';

import { FormControl } from '../shared/FormControl';

const FormikField = ({
  required,
  name,
  label,
  tooltip,
  component: Component,
  componentProps,
  controlProps,
  labelProps,
  showError,
  infoTitle,
  showTooltip,
  infoDetails,
}) => (
  <Field name={name}>
    {({ field, form }) => {
      const error = getIn(form.errors, field.name);
      const touched = getIn(form.touched, field.name);

      const hasError = (showError || touched) && !!error;

      return (
        <FormControl
          hasError={hasError}
          showError={showError}
          error={error}
          label={label}
          tooltip={tooltip}
          required={required}
          infoTitle={infoTitle}
          infoDetails={infoDetails}
          disabled={componentProps?.disabled}
          labelProps={labelProps}
          showTooltip={showTooltip}
          {...controlProps}
        >
          <Component
            hasError={hasError}
            name={name}
            field={field}
            form={form}
            {...componentProps}
          />
        </FormControl>
      );
    }}
  </Field>
);

export default React.memo(FormikField);
